<template>
  <div>
    <validation-provider
      #default="{ errors }"
      name="dispute"
      :rules="requiredField ? 'required' : ''"
    >
      <b-form-group
        label="Disputa"
        label-for="dispute"
      >
        <v-select
          id="dispute"
          v-model="dataSelected"
          :class="errors.length > 0 ? 'error-select' : ''"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :filter="fuseSearch"
          label="name"
          :options="dataOptions"
          :placeholder="'Disputa'"
          :disabled="readonly"
          :clearable="!readonly"
          @open="onCreate()"
        >
          <template #option="{ name }">
            <span>{{ name }} </span>
          </template>

          <template #selected-option="{ name }">
            <span>{{ name }} </span>
          </template>

          <template #no-options>
            Não há opções de disputa.
          </template>
        </v-select>
        <small class="text-danger">{{ errors[0] }}</small>
      </b-form-group>
    </validation-provider>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import {
  BFormGroup,
} from 'bootstrap-vue'
import {
  ValidationProvider,
} from 'vee-validate'
import { required } from '@validations'
import Fuse from 'fuse.js'
import syslic from '@/syslic'

export default {
  components: {
    BFormGroup,
    ValidationProvider,
    vSelect,
  },
  model: {
    prop: 'value',
    event: 'dataChange',
  },
  props: {
    value: {
      type: [Object, String],
      required: true,
    },
    readonly: {
      type: Boolean,
      required: true,
    },
    requiredField: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    const dataOptions = []
    const dataSelected = ''

    return {
      dataOptions,
      dataSelected,
      required,
    }
  },
  watch: {
    value: function updateProp(val) {
      this.dataSelected = val
    },
    dataSelected: function updateData(val) {
      if (val === null) {
        this.$emit('dataChange', '')
      } else {
        this.$emit('dataChange', val)
      }
    },
  },
  created() {
    this.onCreate()
  },
  methods: {
    onCreate() {
      syslic
        .bidding
        .dispute
        .fetchAllDispute()
        .then(response => {
          this.dataOptions = response.results
          this.$emit('ready', true)
        })
        .catch(() => {
          this.$emit('ready', true)
        })
    },
    fuseSearch(options, search) {
      const fuse = new Fuse(options, {
        keys: ['name'],
        shouldSort: true,
      })
      return search.length
        ? fuse.search(search).map(({ item }) => item)
        : fuse.list
    },
  },
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
